export const FOUNDATION = {
    name: 'Foundation',
    backgroundColor: '#FFF4E5',
    boxColor: '#F9BB30',
    color: 'var(--gray800)',
};

export const CONCEPTUAL_LINK = {
    name: 'Conceptual Link',
    backgroundColor: '#eef7f4',
    boxColor: '#98D0C1',
    color: 'var(--gray800)',
};

export const CORE = {
    name: 'Core',
    backgroundColor: '#F0F1F6',
    boxColor: '#9AB1D8',
    color: 'var(--gray800)',
};

export const EXPANSION = {
    name: 'Expansion',
    backgroundColor: '#FEEDE0',
    boxColor: '#EE7D2E',
    color: 'var(--gray800)',
};

export const GROWTH = {
    name: 'Growth',
    backgroundColor: '#F8F6E7',
    boxColor: '#C5D439',
    color: 'var(--gray800)',
};

export const B1_PRELIMINARY_TRAINING = {
    name: 'B1 Preliminary Training',
    backgroundColor: '#FBEDF0',
    boxColor: '#E6859A',
    color: 'var(--gray800)',
};

export const FAST_TRACK = {
    name: 'Fast Track',
    backgroundColor: '#D9E7F3',
    boxColor: '#0062B3',
    color: 'var(--color-text-inverse)',
};
